var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"container",staticClass:"overflow-y-auto pa-0",staticStyle:{"border-top":"1px solid #ddd"},attrs:{"fluid":""}},_vm._l((_vm.items),function(item,index){return _c('v-row',{key:item.raw.workorderId,staticClass:"mx-0"},[_c('as-item-card',{attrs:{"item":item,"options":_vm.asOptions}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }